<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <div v-if="!fixed">
      <el-form-item label="Aspect ratio">
        <el-radio-group v-model="aspectRatio" @change="setWidth()">
          <el-radio label>Custom</el-radio>
          <el-radio v-for="opt in aspectRatioOptions" :key="opt" :label="opt">{{
            opt
          }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-for="key in ['height', 'width']"
        :key="key"
        :label="_.capitalize(key)"
        label-width="100px"
        :prop="key"
        :rules="
          isFacebookLivestream
            ? [
                ...numberRule(
                  key,
                  limit.size[`min${_.capitalize(key)}`],
                  limit.size[`max${_.capitalize(key)}`]
                ),
                ...facebookLivestreamSizeRule(),
              ]
            : [
                ...numberRule(
                  key,
                  limit.size[`min${_.capitalize(key)}`],
                  limit.size[`max${_.capitalize(key)}`]
                ),
              ]
        "
        v-show="key === 'height' || !aspectRatio"
      >
        <el-input
          type="number"
          :min="limit.size[`min${_.capitalize(key)}`]"
          :max="limit.size[`max${_.capitalize(key)}`]"
          v-model.number="item[key]"
        >
          <template slot="append"
            >px</template
          >
        </el-input>
      </el-form-item>
    </div>
    <layout-item
      v-for="key in ['vertical', 'horizontal']"
      :key="key"
      :label="_.capitalize(key)"
      :type="key"
      :min="limit[key].minPadding"
      :max="limit[key].maxPadding"
      v-model="item[key]"
      v-if="item[key]"
    ></layout-item>
  </el-form>
</template>

<script>
import LayoutItem from "@/components/base/forms/layoutItem";
import MixFormRule from "@/components/mixins/formRule";
export default {
  props: {
    value: Object,
    minWidth: {
      type: Number,
      default: function() {
        return 1;
      },
    },
    minHeight: {
      type: Number,
      default: function() {
        return 1;
      },
    },
    maxWidth: Number,
    maxHeight: Number,
    fixed: Boolean,
    isFacebookLivestream: {
      type: Boolean,
      default: function() {
        return false;
      },
    },
  },
  data() {
    return {
      item: this.value,
      aspectRatio: "",
      aspectRatioOptions: ["16:9", "4:3"],
    };
  },
  components: {
    LayoutItem,
  },
  mixins: [MixFormRule],
  watch: {
    value(newVal) {
      this.item = newVal;
    },
    "item.height"(newVal) {
      this.setWidth();
    },
    item(newVal) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    limit() {
      return {
        size: {
          minWidth: this.minWidth,
          maxWidth: this.maxWidth,
          minHeight: this.minHeight,
          maxHeight: this.maxHeight,
        },
        vertical: {
          minPadding: 0,
          maxPadding:
            this.maxHeight - this.item.height > 0
              ? Math.round((this.maxHeight - this.item.height) / 2)
              : 0,
        },
        horizontal: {
          minPadding: 0,
          maxPadding:
            this.maxWidth - this.item.width > 0
              ? Math.round((this.maxWidth - this.item.width) / 2)
              : 0,
        },
      };
    },
  },
  async mounted() {
    await this.$nextTick();
    const r = this.gcd(this.item.width, this.item.height),
      w = this.item.width / r,
      h = this.item.height / r;

    this.aspectRatio = this.aspectRatioOptions.includes(`${w}:${h}`)
      ? `${w}:${h}`
      : "";
  },
  methods: {
    gcd(a, b) {
      return b == 0 ? a : this.gcd(b, a % b);
    },
    setWidth() {
      if (this.aspectRatioOptions.includes(this.aspectRatio)) {
        const r = this.aspectRatio.match(/(\d+):(\d+)/i),
          w = r[1],
          h = r[2];
        this.item.width = Math.round((this.item.height * w) / h);
      }
    },
  },
};
</script>

<style lang="sass" scoped></style>
